import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  setSelectedChars
} from '../../../actions';
import {
  labelPrependAsType, labelAppendAsType, valueAsType
} from '../charts.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faClock, faInfo } from '@fortawesome/free-solid-svg-icons';
import './EsgProductRow.css';
import ReactTooltip from 'react-tooltip';

import i18n from '../../../i18n';
//import { part } from 'core-js/core/function';


library.add(faClock, faAngleDown, faAngleUp, faInfo);


class EsgProductRow extends Component {

  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(3)}%` : '-';
  }


  setSelectedChars(char) {
    this.props.setSelectedChars(char);
  }

  getValues(name, type, data) {
    const values = [];
    for (let i = 0; i < data.length; i++) {
      const fund = data[i];
      if (fund.esgProductInvolvementMetrics) {
        const involvements = fund.esgProductInvolvementMetrics[fund.esgProductInvolvementMetrics.length - 1];
        let value = '-';
        const index = involvements.keys.findIndex((x) => x === name);
        if (index !== -1) {
          value = labelPrependAsType(type, fund.entityCCY) + valueAsType(involvements.values[index], type) + labelAppendAsType(type);
        }
        values.push(value);
      } else {
        values.push('-');
      }
    }
    return values;
  }


  getPIContribsValues(name, type, data, rank) {
    const values = [];
    for (let i = 0; i < data.length; i++) {
      const fund = data[i];
      if (fund.esgProductInvolvementContributions) {

        const involvements = fund.esgProductInvolvementContributions[fund.esgProductInvolvementContributions.length - 1];
        let value = '-';
        const prods = involvements.keys.filter((x) => x.includes(name + '|'));
        if (prods !== -1) {
          value = prods[rank - 1]
        }
        values.push(value);
      } else {
        values.push('-');
      }
    }
    return values;
  }

  renderContributors() {
    const {
      data,
      charName,
      charType,
    } = this.props;

    const withPIContribs = data;
    const PIContribsHighest = this.getPIContribsValues(charName, charType, withPIContribs, 1);
    const PIContribsSecondHighest = this.getPIContribsValues(charName, charType, withPIContribs, 2);
    const PIContribsThirdHighest = this.getPIContribsValues(charName, charType, withPIContribs, 3);

    function getProdInvDetails(data, rowIdx) {

      return data.map((value, idx) => {
        let rowIndex = rowIdx
        if ((value) && value !== '-') {
          let parts = value.split('|')
          const name = parts ? parts[4].replace(/&amp;/g, '&') : '-'
          const weight = parts[5];
          const identifier = parts[3];
          if ((!value) || (value === '-') || (value === '0.000')) {
            return (<td key={idx} className='textCenter'>-</td>);
          } else {
            let valueClass = 'textCenter';
            return (
              <Fragment >
                <td key={`${rowIndex}-${idx}`} className={valueClass}>{identifier}
                  <div>
                    {weight}
                    <FontAwesomeIcon style={{ marginLeft: '4px', cursor: 'pointer', color: 'white', background: 'grey', borderRadius: '50%', border: '1px solid grey', fontSize: '12px', width: '.9em' }} data-tip data-for={`contribPi'${rowIndex}-${idx}`} icon="info" size="lg" />
                    <ReactTooltip id={`contribPi'${rowIndex}-${idx}`} type='light' className="esgPi" effect="float">
                      <div dangerouslySetInnerHTML={{ __html: name }} />
                    </ReactTooltip>
                  </div>
                </td>
              </Fragment>

            );
          }
        } else {
          return (
            <td className='textCenter' key={idx} >-</td>
          );
        }
      })
    }

    return (
      <Fragment>
        <tr>
          <td colSpan={1}>
            &nbsp;&nbsp; {i18n.t('highest-contributor')}
            <div>&nbsp;&nbsp; &nbsp;&nbsp;% of Fund </div>
          </td>
          {getProdInvDetails(PIContribsHighest, 1)}
        </tr>
        <tr>
          <td colSpan={1}>
            &nbsp;&nbsp;{i18n.t('second-highest-contributor')}
            <div> &nbsp;&nbsp;&nbsp;&nbsp;% of Fund </div>
          </td>
          {getProdInvDetails(PIContribsSecondHighest, 2)}

        </tr>
        <tr>
          <td colSpan={1}>
            &nbsp;&nbsp;{i18n.t('third-highest-contributor')}
            <div> &nbsp;&nbsp;&nbsp;&nbsp;% of Fund </div>
          </td>
          {getProdInvDetails(PIContribsThirdHighest, 3)}
        </tr>
      </Fragment>
    )
  }

  render() {
    const {
      data,
      selectedChars,
      displayName,
      charName,
      charType,
      bold,
    } = this.props;

    const withProdContribs = data;
    const values = this.getValues(charName, charType, withProdContribs);
    const columns = values.map((value, idx) => {
      let match = Math.max(...values.filter((val) => { return val !== null && val !== 'N/A' && val !== '-'; }));
      if (bold === 'min') {
        match = Math.min(...values.filter((val) => { return val !== null && val !== 'N/A' && val !== '-'; }));
      }
      if ((!value) || (value === '-')) {
        return (<td key={idx} className='textCenter'>N/A</td>);  // maybe a -?
      } else {
        let valueClass = 'textCenter';
        if (Number(value) === match) {
          valueClass = 'textCenterBold';
        }


        if ((value !== '0.00')) {
          return (
            <td key={idx} className={valueClass}>{this.formatPercent(value)}</td>
          );
        }

        else {
          return (
            <td key={idx} className='textCenter'>NA</td>
          );
        }
      }
    });


    if (values.filter((x) => x !== '-').length > 0) {
      return (
        <Fragment>
          <tr>
            <td className='textLeft'>
              <div onClick={() => this.setSelectedChars(charName)} style={{ cursor: 'pointer' }}>
                {selectedChars.findIndex((x) => x === charName) === -1 &&
                  <FontAwesomeIcon style={{ color: '#050139' }} icon='angle-down' />
                }
                {selectedChars.findIndex((x) => x === charName) !== -1 &&
                  <FontAwesomeIcon style={{ color: '#050139' }} icon='angle-up' />
                }
                &nbsp;&nbsp;{i18n.t(displayName)}
              </div>
            </td>
            {columns}
          </tr>
          {selectedChars.findIndex((x) => x === charName) !== -1 &&
            <Fragment>  {this.renderContributors()}</Fragment>
          }
        </Fragment>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    selectedChars: state.params.selectedChars,
  };
}

export default connect(mapStateToProps, {
  setSelectedChars,
})(EsgProductRow);

